import script from "./SingleLensDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleLensDetails.vue?vue&type=script&setup=true&lang=js"

import "./SingleLensDetails.vue?vue&type=style&index=0&id=192d4dc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-192d4dc4"]])

export default __exports__